import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const useDeleteEmployerTerminationConfigQuery = () => {
  const { mutateAsync, isPending, isSuccess } = useMutation((id: string) =>
    api.delete(API_URL.ORGANIZATIONS_TERMINATION_BY_ORGANIZATION_ID(id))
  );
  return {
    cancelTermination: mutateAsync,
    isLoading: isPending,
    isSuccess,
  };
};
